
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';

interface CsvValidationBadgeProps {
  isValid: boolean;
  validationErrors: string[];
}

export const CsvValidationBadge = ({ isValid, validationErrors }: CsvValidationBadgeProps) => {
  if (isValid) {
    return <CheckCircle className="h-4 w-4 text-green-600" />;
  }

  return (
    <div className="flex items-center gap-1">
      <XCircle className="h-4 w-4 text-red-600" />
      {validationErrors.length > 0 && (
        <>
          <AlertCircle className="h-4 w-4 text-orange-600" />
          <span className="text-xs text-orange-600">
            {validationErrors.join(', ')}
          </span>
        </>
      )}
    </div>
  );
};
